// Core
import React from 'react';
import PropTypes from 'prop-types';

// Style
import './styles.scss'
import { useTranslation } from 'react-i18next';

const Banner = (props) => {
  const { t } = useTranslation();
  const { title,count, desc, ...rest } = props;
  return (
    <div className='__banner_commn'>
        <div className='_bnr__top_gradient'></div>
        <h1>{title}</h1>
        {desc && <p>{desc}</p>}
        {!!count && <span className='__count'>{t('total')} :{` ${count}`}</span>}
    </div>
  );
};

export default Banner;

Banner.propTypes = {
  title: PropTypes.string,
};
